import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationENG from "./locales/eng/translation.json";
import translationHIN from "./locales/hin/translation.json";
import translationTEL from "./locales/telugu/translation.json";
import translationBAN from "./locales/bangla/translation.json";
import translationURD from "./locales/urdu/translation.json";
import translationRUS from "./locales/rs/translation.json";

// the translations
const resources = {
  en: {
    translation: translationENG,
  },
  eng: {
    translation: translationENG,
  },
  hi: {
    translation: translationHIN,
  },
  hin: {
    translation: translationHIN,
  },
  te: {
    translation: translationTEL,
  },
  telugu: {
    translation: translationTEL,
  },
  bn: {
    translation: translationBAN,
  },
  bangla: {
    translation: translationBAN,
  },
  ur: {
    translation: translationURD,
  },
  urdu: {
    translation: translationURD,
  },
  ru: {
    translation: translationRUS,
  },
  russia: {
    translation: translationRUS,
  },
  rs: {
    translation: translationRUS,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "en",
    fallbackLng: "en",

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
